import React, { Component } from 'react'
import { connect } from "react-redux"
import trans from "trans"
import {
    Button,
    DataRow,
    DataCell,
    css,
    Icon,
    Theme,
} from "@bdfx/mergado-ui-kit"
import { updateInputValue as change } from "app/reducers/form"
import { iconDisabledColor } from "template-edit/components/tools-panel";
import LayerGroupType from "shape-entities/types/layerGroup";
import { intboolean } from "app/types/app-types";
import { selectLayers } from "../reducers";
import { setActiveGroupId } from "shape-edit/reducers";
import uniqueId from "app/helpers/unique_id";
import { createGroupFromSelected,  getFormName, reorderShapes } from "shape-edit/forms/helpers";
import { AlternativeTemplate, Template } from "app/types/model-types";
import { LayerPreview } from './shape-list-item'
import { selectFormValues } from 'app/reducers/form'
import { forEach, intersection, omitBy, sortBy } from 'lodash'
import { TemplateOrAlternativeTemplateType } from 'template-edit/undoRedoReducers'

interface Props {
    isAlt: boolean
    form: TemplateOrAlternativeTemplateType
    group: LayerGroupType
    handleClick: (group: LayerGroupType, event: MouseEvent) => void
    change: typeof change
    activeGroupId: string
    selectedLayers: string[]
    selectLayers: typeof selectLayers
    setActiveGroupId: typeof setActiveGroupId
}

interface State {
    isHidden: intboolean
}

class ShapeListGroupItem extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            isHidden: props.form.shapes[props.group.list[0]].is_hidden,
        }
    }

    handleClick = (event: PointerEvent) => {
        const { group } = this.props
        this.props.handleClick(group, event)
    }

    toggleHideGroup = () => {
        const { group, form, isAlt } = this.props
        const { isHidden } = this.state

        const formName = getFormName(isAlt)

        let newShapes = {}
        Object.keys(form.shapes).forEach((index) => {
            newShapes[index] = form.shapes[index]
            if (group.list.includes(index)) {
                newShapes[index].is_hidden = isHidden === 1 ? 0 : 1
            }
        })

        this.setState({ isHidden: isHidden === 1 ? 0 : 1 })

        this.props.change(formName, 'shapes', newShapes)
    }

    handleUngroup = (groupId: string) => {
        const { group, form, isAlt } = this.props

        const formName = getFormName(isAlt)

        const newGroups = form.groups.filter(g => g.index !== groupId)
        this.props.selectLayers(group.list)
        this.props.setActiveGroupId(null)
        this.props.change(formName, 'groups', newGroups)
    }

    handleRightClick = (e: PointerEvent, groupId: string) => {
        e.preventDefault()
        this.handleUngroup(groupId)
    }


    render() {
        const { group, activeGroupId, form, isAlt, selectedLayers } = this.props
        const { isHidden } = this.state

        const formName = getFormName(isAlt)

        const isActive = group.index === activeGroupId
        const isSelected = (selectedLayers.length !== group.list.length && intersection(group.list, selectedLayers).length === group.list.length)

        return (
            <DataRow dataId={JSON.stringify(group.list)} className={`layer-group ${isSelected ? 'selected-row' : 'not-selected-row'} ${isActive ? 'active-row' : ''} ${isHidden ? 'hidden-shape' : ''}`}>
                <DataCell
                    key="1"
                    style={{ textAlign: 'center' }}>
                    <Button type="void" size="tiny" color="nocolor"
                        icon={<Icon type={'arrows-v'} style={{ cursor: 'move' }} color={isHidden ? iconDisabledColor : Theme.blue} />}
                        style={{ marginLeft: '-10px' }}
                        className="drag-handle"
                    />
                </DataCell>
                <DataCell key="2" onClick={(e) => this.handleClick(e)} style={{ cursor: 'pointer', textAlign: "center" }} className={isHidden ? 'hidden-preview' : ''}>
                    <LayerPreview color={'#fff'} background={'#fff'}>
                        <Icon type={'object-group'} size={30} color={'#a3a3a3'} />
                    </LayerPreview>
                </DataCell>
                <DataCell
                    key="3"
                    onClick={(e) => this.handleClick(e)}
                    onContextMenu={(e) => this.handleRightClick(e, group.index)}
                    style={{
                        cursor: 'pointer',
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        fontStyle: isHidden ? 'italic' : 'normal',
                        maxWidth: '200px',
                    }}>
                    <em>{group.name}</em>
                </DataCell>
                <DataCell
                    key="5"
                    style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
                    <Button
                        type="void"
                        color="nocolor"
                        size="tiny"
                        onClick={(e) => this.toggleHideGroup()}
                        title={trans('toggle_visibility')}
                        icon={<Icon type={isHidden ? 'eye-slash' : 'eye'} color={isHidden ? iconDisabledColor : Theme.blue} size={20} />}
                    />
                    <Button
                        type="void"
                        size="tiny"
                        color="nocolor"
                        icon={<Icon type={'object-ungroup'} color={isHidden ? iconDisabledColor : Theme.blue} />}
                        title={trans('ungroup')}
                        onClick={(e) => this.handleUngroup(group.index)}
                    />
                    <Button
                        type="void"
                        size="tiny"
                        color="nocolor"
                        icon={<Icon type={'trash'} color={isHidden ? iconDisabledColor : Theme.blue} />}
                        title={trans('delete_layers')}
                        onClick={(e) => {
                            const newShapes = omitBy(form.shapes, (shape, index) => group.list.includes(index))
                            const newGroups = form.groups.filter(g => g.index !== group.index)

                            if (activeGroupId === group.index) {
                                //deselect all
                                this.props.selectLayers()
                                this.props.setActiveGroupId(null)
                            }

                            this.props.change(formName, 'groups', newGroups)
                            this.props.change(formName, 'shapes', newShapes)
                        }}
                    />
                    <Button
                        type="void"
                        size="tiny"
                        color="nocolor"
                        icon={<Icon type={'copy-light'} color={isHidden ? iconDisabledColor : Theme.blue} />}
                        title={trans("duplicate_layers")}
                        onClick={(e) => {
                            let newIndexes = []
                            let newShapes = []

                            sortBy(form.shapes, [(shape) => new Number(shape.priority)])
                                .filter(shape => (group.list.includes(shape.index)))
                                .forEach(shape => {
                                    const newShapeIndex = uniqueId()
                                    newIndexes.push(newShapeIndex)
                                    newShapes[newShapeIndex] = {
                                        ...shape,
                                        id: null,
                                        index: newShapeIndex,
                                        priority: shape.priority + 1
                                    }
                                })

                            let allIndexOrder = []
                            const insertAfterIndex = group.list[group.list.length - 1]

                            forEach(form.shapes, (shape) => {
                                allIndexOrder.push(shape.index)

                                if (shape.index === insertAfterIndex) {
                                    allIndexOrder.push(...newIndexes)
                                }
                            })

                            reorderShapes({ ...form.shapes, ...newShapes }, allIndexOrder)
                            this.props.selectLayers(newIndexes)
                            createGroupFromSelected()
                        }}
                    />
                </DataCell>
            </DataRow>
        )
    }
}

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        form: selectFormValues(state, getFormName(state.isAlt)),
        activeGroupId: state.activeGroupId,
        selectedLayers: state.selectedLayers,
    }
}

export default connect(mapStateToProps, {
    selectLayers,
    setActiveGroupId,
    change,
})(ShapeListGroupItem)